import { LoadableAfterPaint } from '@confluence/loadable';

export const LivePagesFeedbackBannerLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LivePagesFeedbackBanner" */ './LivePagesFeedbackBanner'
			)
		).LivePagesFeedbackBanner,
});
